import { Inject, Injectable } from '@angular/core';
import { ChatContextRef, ENV, Environment } from 'lib-trend-core';
import { ChatContextRefNavigator, contextRefRoute } from 'lib-trend-core/chat';
import { ChatAppConstants } from '../chat-app.constants';

/**
 * Work references open the PRODUCT — SPEC-2026-09-internal-chat-pwa (T-38 · RF-25).
 *
 * The chat app has no attendance, deal or contact screens: a reference opens the record
 * in the product, in a tab of its own name, so repeated clicks reuse that tab and the
 * user's main product tab is never navigated away from what they were doing. The
 * product enforces its own permissions on the record.
 */
@Injectable()
export class ChatAppContextRefNavigator implements ChatContextRefNavigator {

  constructor(@Inject(ENV) private readonly environment: Environment) { }

  open(reference: ChatContextRef): void {
    const url = this.buildProductUrl(reference);
    if (!url) return;
    const opened = window.open(url, ChatAppConstants.productWindowName);
    opened?.focus();
  }

  /** Absolute product URL of a reference, or null when it has no destination. */
  buildProductUrl(reference: ChatContextRef): string | null {
    const route = contextRefRoute(reference);
    const base = String(this.environment['trendWebAppUrl'] ?? '').replace(/\/+$/, '');
    if (!route || !base) return null;

    const path = route.commands
      .map((segment, index) => (index === 0 && segment.startsWith('/') ? segment : `/${encodeURIComponent(segment)}`))
      .join('');
    const query = new URLSearchParams(route.queryParams ?? {}).toString();
    return `${base}${path}${query ? `?${query}` : ''}`;
  }
}
